import React from "react";
import { Check } from "lucide-react";
import { SERVICES } from "../mock";

const Services = () => {
  return (
    <section id="services" className="py-24 md:py-32 bg-[#efe7d6]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-20 reveal">
          <p className="kicker mb-5">Our Services</p>
          <h2 className="font-display display-tight text-5xl md:text-6xl text-[#1f1d1a]">
            Wedding videography <span className="italic font-light">&amp; photography</span> in Essex
          </h2>
          <div className="section-rule mx-auto mt-8" />
          <p className="mt-6 text-[#3a342c]/80 font-light text-[1rem] leading-relaxed">
            Pick film, photo, or both. Either way. Natural, unposed, and made to feel like you.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {SERVICES.map((s, i) => (
            <div key={i} className="reveal group">
              <div className="aspect-[4/5] overflow-hidden mb-7">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
                />
              </div>
              <p className="kicker text-[#8b6f47] mb-3">0{i + 1} / 0{SERVICES.length}</p>
              <h3 className="font-display text-3xl md:text-4xl text-[#1f1d1a] mb-2 display-tight">{s.title}</h3>
              <p className="italic font-serif text-[#6b6259] mb-6">{s.sub}</p>
              <ul className="space-y-3">
                {s.bullets.map((b, j) => (
                  <li key={j} className="flex items-start gap-3 text-sm text-[#3a342c]/90 font-light leading-relaxed">
                    <Check size={15} className="text-[#8b6f47] mt-1 flex-shrink-0" />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
